import {Component, OnInit} from '@angular/core';
import {Menu} from '../../models/menu';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BaseService} from '../../base.service';
import {MenuService} from '../../services/menu.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {HttpErrorResponse} from '@angular/common/http';
import {MenuDto} from '../../dto/menu.dto';

@Component({
  selector: 'app-menu-info',
  templateUrl: './menu-info.component.html',
  styles: []
})
export class MenuInfoComponent implements OnInit {

  private title_component: string;
  private title_panel: string;
  private menu: Menu;
  private currentId: number;
  private modalRef: BsModalRef;

  private menuForm = this.fb.group({
    name: [''],
    message: [''],
    status: [true]
  });

  constructor(
    private modalService: BsModalService,
    private baseService: BaseService,
    private menuService: MenuService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.title_component = 'Menus';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Editar Menu';
    this.currentId = +this.route.snapshot.paramMap.get('id');
    this.getDetail(this.currentId);
  }

  getDetail(id: number): void {
    this.menuService.getDetail(id).subscribe(data => {
      this.menu = data;
      this.fillData();
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('Ocurrió un error:', err.error.message);
      } else {
        console.log('StatusCode: ', err.status);
        console.log('Error:', err.error);
        if (err.error.status === 404) {
          localStorage.setItem('message_404', err.error.detail);
          this.router.navigate(['/dashboard/404']);
        }
      }
    });
  }

  onSubmit(): void {
    const dto = new MenuDto(this.menuForm.get('name').value, this.menuForm.get('message').value, this.menuForm.get('status').value);
    this.menuService.update(this.currentId, dto).subscribe(data => {
      if (data) {
        setTimeout(() => {
          this.baseService.showSuccess('Sus datos se han actualizado con éxito');
          this.router.navigate(['/dashboard/menus']);
        }, 1000);
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log('Error: ', err.error.message);
      } else {
        console.log('StatusCode: ', err.status);
        console.log('Error: ', err.error);
        if (err.error.status === '404') {
          localStorage.setItem('message_404', err.error.detail);
          this.router.navigate(['/dashboard/404']);
        }
      }
    });
  }

  fillData(): void {
    this.menuForm.setValue({
      name: this.menu.name,
      message: this.menu.message,
      status: this.menu.status
    });
  }

  goBack(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/menu/menu-info.component.ts